import React, { Component } from 'react';
import './DashboardPage.css';
import Page from '../../components/page/Page';
import Label from '../../components/label/Label';
import Divider from '../../components/divider/Divider';
import InventoryCheckCard from './inventoryCheckCard/InventoryCheckCard';
import InventoryOverviewCard from './inventoryOverviewCard/InventoryOverviewCard';
import UsageCard from './usageCard/UsageCard';
import UsersCard from './usersCard/UsersCard';
import models from '../../model/models';
import mainAPI from '../../api/MainAPI';
import utils from '../../utils/utils';
import history from '../../history';
import UpdateTitle from '../../components/updateTitle/UpdateTitle';

export default class DashboardPage extends Component {
	constructor(props) {
		super(props);
		this.state = { drugs: [], users: [], daysRemaining: {}, lastDiscrepancyCreatedOn: null };
	}

	componentDidMount = async () => {
		this.drugSubscribeId = models.drug.onChange(this._drugsChanged);
		this.typeSubscribeId = models.drug_type.onChange(this._drugTypeChanged);
		this.userSubscribeId = models.user.onChange(this._usersChanged);
		this.unitSubscribeId = models.unit.onChange(this._unitChanged);
		this.boxCheckSubscribeId = models.box_check.onChange(this._boxCheckChanged);
		this.boxSubscribeId = models.drug_box.onChange(this._boxChanged);
		let promises = [];
		// These are highly suspect to me (calls administeredOfficial and wasted)
		// They both return a large set of data (7KB and 3KB) respectively.
		// It looks like the administered is used to calculate the days remaining
		// which is passed to the InventoryOverviewCard component and displays days of supply left
		// I'm sure we can optimize this.

		// Need to look into wasted and what it is used for.
		promises.push(await mainAPI.stock_move_record.administeredOfficial(this._timeStamp(365)));
		promises.push(await mainAPI.stock_move_record.wasted(this._timeStamp(365)));
		promises.push(await mainAPI.discrepancy.latest());
		promises.push(await mainAPI.box_check.user_stats());
		let result = await Promise.all(promises);
		let administered = result[0];
		let wasted = result[1];
		let lastDiscrepancy = result[2];
		let boxCheckStats = result[3];
		lastDiscrepancy = lastDiscrepancy || {};
		this.setState({ boxCheckStats, administered, wasted, lastDiscrepancyCreatedOn: lastDiscrepancy.created_on }, () => {
			let allowed = models.drug_type.allowed();
			let daysRemaining = {};
			for (let i in allowed) {
				daysRemaining[allowed[i].id] = this._daysOfSupplyLeft(allowed[i].id);
			}
			this.setState({ daysRemaining });
		});
	};

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.drugSubscribeId);
		models.user.unsubscribe(this.userSubscribeId);
		models.unit.unsubscribe(this.unitSubscribeId);
		models.box_check.unsubscribe(this.boxCheckSubscribeId);
		models.drug_box.unsubscribe(this.boxSubscribeId);
		models.drug_type.unsubscribe(this.typeSubscribeId);
	};

	_timeStamp = (days) => {
		return Date.now() - 1000 * 60 * 60 * 24 * parseInt(days);
	};

	_drugsChanged = (drugs) => {
		this.setState({ drugs });
	};

	_drugTypeChanged = () => {
		const drug_types = models.drug_type.allowed();
		this.setState({ drug_types });
	};

	_usersChanged = (users) => {
		this.setState({ users });
	};

	_unitChanged = (units) => {
		this.setState({ units });
	};

	_boxCheckChanged = async () => {
		if (!this.state.boxCheckStats) return;
		let boxCheckStats = await mainAPI.box_check.user_stats();
		this.setState({ boxCheckStats });
	};

	_boxChanged = (drug_box) => {
		this.setState({ drug_box });
	};

	_userCount = () => {
		let count = 0;
		for (let i in this.state.users) {
			count++;
		}
		return count;
	};

	_unitCount = () => {
		let count = 0;
		for (let i in this.state.units) {
			count++;
		}
		return count;
	};

	_dailyCheckCount = () => {
		let stats = this.state.boxCheckStats || {};
		return stats.num_checks || '';
	};

	_checkPercent = () => {
		let stats = this.state.boxCheckStats || {};
		let percent = stats.percent || 0;
		if (percent > 100) {
			return 100;
		}
		if (percent != parseInt(percent)) {
			return percent.toFixed(2);
		}

		return percent;
	};

	_miligramsUsedLastYear = (type) => {
		let volume = 0;
		volume += this._volumeUsed('administered', type);
		volume += this._volumeUsed('wasted', type);
		return volume;
	};

	_volumeRemaining = (type) => {
		let volume = 0;
		for (let i in this.state.drugs) {
			if (type && this.state.drugs[i].type !== type) continue;
			volume += this.state.drugs[i].stock_move_record__quantity;
		}
		return volume;
	};

	_volumeUsedPerDay = (type) => {
		let volumeUsed = this._miligramsUsedLastYear(type);
		return volumeUsed / 0.1;
	};

	_volumeUsed = (move_type, type) => {
		let moves = this.state[move_type];
		let volume = 0;
		for (let i in moves) {
			let move = moves[i];
			let drug = models.drug.obj(move.drug_id);
			if (type && drug && drug.type !== type) continue;
			volume += Math.abs(move.quantity);
		}
		return volume;
	};

	_daysOfSupplyLeft = (type) => {
		let dailyNeed = this._volumeUsedPerDay(type);
		let remaining = this._volumeRemaining(type);
		if (remaining === 0) return 0;
		let days = remaining / dailyNeed;
		if (days && days.toFixed) {
			let number = parseInt(days * 100 || 0);
			if (Number.isNaN(number)) return 0;
			return utils.display_number(number);
		}
		return 0;
	};

	_lastDiscrepancyDate = () => {
		if (!this.state.lastDiscrepancyCreatedOn) {
			return null;
		}
		let dt = utils.server_to_client_datetime(this.state.lastDiscrepancyCreatedOn);
		if (Number.isNaN(dt.getFullYear())) {
			return 'Never';
		}
		return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
	};

	_daysSinceLastDiscrepancy = () => {
		if (!this.state.lastDiscrepancyCreatedOn) {
			return ' ';
		}
		let dt = utils.server_to_client_datetime(this.state.lastDiscrepancyCreatedOn);
		let days = parseInt((Date.now() - dt.getTime()) / (1000 * 60 * 60 * 24));
		if (Number.isNaN(days)) {
			return null;
		}
		return days + ' DAYS AGO';
	};

	render() {
		return (
			<Page className="g-dashboard-page">
				<UpdateTitle newTitle="Inventory checks & Inventory at a glance" originalTitle="LogRx" />
				<div className="high-level-cards">
					<HighLevelCard title="ACTIVE USERS" count={this._userCount()} bottom={this._userCount() + ' TOTAL'} />
					<HighLevelCard title="ACTIVE UNITS" count={this._unitCount()} bottom={this._unitCount() + ' TOTAL'} />
					<HighLevelCard
						title="INVENTORY CHECKS TODAY"
						count={this._dailyCheckCount()}
						bottom={this._checkPercent() + '% OF ACTIVE UNITS'}
					/>
					{/*<HighLevelCard title="DAYS OF SUPPLY LEFT" count={this._daysOfSupplyLeft()} bottom="10% ABOVE PAR"/>*/}
					<HighLevelCard
						onClick={() => {
							history.navigate('/reports/discrepancy');
						}}
						title="LAST DISCREPANCY"
						count={this._lastDiscrepancyDate()}
						bottom={this._daysSinceLastDiscrepancy()}
					/>
				</div>
				<div className="cards">
					<InventoryCheckCard />
					<InventoryOverviewCard drugs={this.state.drugs || []} daysRemaining={this.state.daysRemaining} />
					{/*<UsageCard />*/}
					{/*<UsersCard />*/}
				</div>
			</Page>
		);
	}
}

let HighLevelCard = (props) => {
	return (
		<div onClick={props.onClick} className="g-high-level-card">
			<Label small black>
				{props.title}
			</Label>
			<Label very-large black>
				{props.count}
			</Label>
			<Divider />
			<Label white small>
				{props.bottom}
			</Label>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/pages/dashboardPage/DashboardPage.jsx